<div class="row mt-3 mb-2">
	<seira-public-table
		[hasFooter]="true"
		[hasHeader]="false"
		[info]="false"
		[searching]="false"
		[columns]="colunas"
		[scrollX]="true"
		[data]="dadosTabela"
		[dtOptions]="dtOptions" />
</div>
